var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvertMonarch1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 3C46.3594 3 58 14.6407 58 29C58 43.3594 46.3594 55 32 55C17.6406 55 6 43.3594 6 29C6 14.6407 17.6406 3 32 3Z",
    stroke: "#E3000F",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0094 37.8097C52.4952 37.8097 59.3744 39.2429 59.3744 41.011C59.3744 42.7786 52.4952 44.2118 44.0094 44.2118C35.5236 44.2118 28.6445 42.7786 28.6445 41.011C28.6445 39.2429 35.5236 37.8097 44.0094 37.8097Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0094 37.8097C52.4952 37.8097 59.3744 39.2429 59.3744 41.011C59.3744 42.7786 52.4952 44.2118 44.0094 44.2118C35.5236 44.2118 28.6445 42.7786 28.6445 41.011C28.6445 39.2429 35.5236 37.8097 44.0094 37.8097Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3242 19.1025H59.105V41.6504H28.3242V19.1025Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7151 15.7437C52.201 15.7437 59.08 17.1769 59.08 18.945C59.08 20.7126 52.201 22.1458 43.7151 22.1458C35.2294 22.1458 28.3506 20.7126 28.3506 18.945C28.3506 17.1769 35.2294 15.7437 43.7151 15.7437Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7151 15.7437C52.201 15.7437 59.08 17.1769 59.08 18.945C59.08 20.7126 52.201 22.1458 43.7151 22.1458C35.2294 22.1458 28.3506 20.7126 28.3506 18.945C28.3506 17.1769 35.2294 15.7437 43.7151 15.7437Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1783 40.2986L26.4262 41.7866L25.8103 43.8506C22.5621 43.6586 18.9541 43.5546 15.0022 43.5546C10.3701 43.5546 6.77011 43.7225 4.21025 44.0426L3.87427 41.3066C4.41813 41.3066 4.81838 41.3386 5.06624 41.4026C5.38638 41.3386 5.81837 41.3066 6.37024 41.3066C7.81024 41.1546 9.15425 40.6425 10.3942 39.7785C11.6422 38.9145 12.7141 37.8426 13.6341 36.5625C14.5461 35.2827 15.2503 33.9466 15.7461 32.5626C16.2424 31.1706 16.4902 29.9306 16.4902 28.8266C16.4902 27.3226 16.1301 26.0346 15.4021 24.9386C14.6821 23.8507 13.6663 23.3066 12.3623 23.3066C11.0263 23.4026 9.95437 23.9389 9.14624 24.9148C8.33824 25.8986 7.9221 27.2346 7.89823 28.9226C7.93037 29.1787 7.94625 29.5627 7.94625 30.0666H6.55424C6.55424 27.2029 7.17037 24.8346 8.4021 22.9706C9.62623 21.1069 11.5141 20.1306 14.0422 20.0426C15.1621 20.0426 16.1701 20.3146 17.05 20.8506C17.9224 21.3866 18.6181 22.1466 19.122 23.1146C19.6261 24.0908 19.8982 25.1947 19.9462 26.4266C19.9462 27.8427 19.7221 29.1626 19.2823 30.3868C18.8423 31.6185 18.25 32.7705 17.5141 33.8586C16.7783 34.9546 15.9301 36.0425 14.9622 37.1306C14.0022 38.2186 13.0744 39.2746 12.1783 40.2986Z",
    fill: "#1A1A18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-350 -908)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertMonarch1);
export default __webpack_public_path__ + "static/media/convert_monarch1.cd7b8efa527fcc52e7d885693407c52c.svg";
export { ForwardRef as ReactComponent };